import React from 'react';

export default function BackIcon({ color }) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.46642H18.0667M1 8.46642L9.53333 16.9998M1 8.46642L9.53333 0.999756"
        stroke={color}
      />
    </svg>
  );
}
